import React from 'react';

import { Flex, Spin } from 'antd';

type LoadingPageProps = { tip: string }

export function LoadingPage({ tip }: LoadingPageProps) {
    return (
        <Flex align="center">
            <Spin 
                tip={tip}
                size="large"
                fullscreen 
            />
        </Flex>
    );
}
